import React from 'react'
import {ReactComponent as ReactLogo} from './espice.svg';
import {Link} from 'react-router-dom'
import $ from 'jquery'

class Navbar extends React.Component{

    componentDidMount (){
        
        (function(){
            'use strict';
        
            class Menu {
            constructor(settings) {
                this.menuNode = settings.menuNode;
                this.state = false;
                this.menuStateTextNode = settings.menuStateTextNode || this.menuNode.querySelector('.menu__screen-reader');
                this.menuOpenedText = settings.menuOpenedText || 'Open menu';
                this.menuClosedText = settings.menuClosedText || 'Close menu';
            }
            
            changeState(state) {
                return this.state = !state;
            }
            
            changeStateText(state, node) {
                let text = (state !== true) ? this.menuOpenedText : this.menuClosedText;
                
                node.textContent = text;
                return text; 
            }
                    
            toggleMenuState(className) {   
                
                let state;
                
                if (typeof className !== 'string' || className.length === 0) {
                return console.log('you did not give the class for the toggleState function');
                } 
                    
                state = this.changeState(this.state);
                
                this.changeStateText(state, this.menuStateTextNode);
                this.menuNode.classList.toggle(className);
                
                return state;  
            }
            }
        
            const jsMenuNode = document.querySelector('.menu');
            const demoMenu = new Menu ({
            menuNode: jsMenuNode
            });
            
            function callMenuToggle(event) {
            demoMenu.toggleMenuState('menu_activated');
            }
            
            jsMenuNode.querySelector('.menu__toggle').addEventListener('click', callMenuToggle);
        })();
}

    render(){
        return(
            <div>
                <header><ReactLogo /></header>
                <div className="menu">
                <nav className="menu__nav">
                    <ul className="menu__list r-list">
                    <li className="menu__group">
                        <Link to="/" className="menu__link r-link">Home</Link>
                    </li>
                    <li className="menu__group">
                        <Link to="/team" className="menu__link r-link">Team</Link>
                    </li>
                    <li className="menu__group">
                        <Link to="/acheivments" className="menu__link r-link">Acheivments</Link>
                    </li>
                    <li className="menu__group">
                        <Link to="/contact" className="menu__link r-link">Contact</Link>
                    </li>
                    </ul>
                </nav>
                <button className="menu__toggle r-button" type="button">
                    <span className="menu__hamburger m-hamburger">
                    <span className="m-hamburger__label">
                        <span className="menu__screen-reader screen-reader">Open menu</span>
                    </span>
                    </span>
                </button>
                </div>
            </div>
        )
    }
}

export default Navbar
